import { GlobalWorkerOptions } from 'pdfjs-dist';

/**
 * PDF.js 全局配置服務
 * 提供統一的 Worker 配置和錯誤處理
 */
export class PdfConfigService {
  private static initialized = false;
  
  /**
   * 初始化 PDF.js Worker 配置
   */
  static initializePdfWorker(): void {
    if (this.initialized) {
      return;
    }

    if (typeof GlobalWorkerOptions !== 'undefined') {
      try {
        // 嘗試使用相對路徑（開發環境）
        GlobalWorkerOptions.workerSrc = './assets/js/pdf.worker.min.mjs';
        console.log('PDF Worker 使用相對路徑配置');
      } catch (error) {
        // 回退到絕對路徑（生產環境）
        console.warn('PDF Worker 相對路徑設定失敗，使用絕對路徑:', error);
        GlobalWorkerOptions.workerSrc = '/assets/js/pdf.worker.min.mjs';
      }
    }

    this.initialized = true;
    console.log('PDF Worker 配置完成:', GlobalWorkerOptions.workerSrc);
  }

  /**
   * 驗證 Worker 是否可用
   */
  static async verifyWorker(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        try {
          const testWorkerBlob = new Blob([`
            self.onmessage = function(e) {
              self.postMessage('worker-test-ok');
            };
          `], { type: 'application/javascript' });
          
          const testWorkerUrl = URL.createObjectURL(testWorkerBlob);
          const testWorker = new Worker(testWorkerUrl);
          
          testWorker.onmessage = function(e) {
            if (e.data === 'worker-test-ok') {
              testWorker.terminate();
              URL.revokeObjectURL(testWorkerUrl);
              resolve(true);
            }
          };
          
          testWorker.onerror = function(error) {
            testWorker.terminate();
            URL.revokeObjectURL(testWorkerUrl);
            reject(error);
          };
          
          testWorker.postMessage('test');
          
          // 超時保護
          setTimeout(() => {
            testWorker.terminate();
            URL.revokeObjectURL(testWorkerUrl);
            reject(new Error('Worker test timeout'));
          }, 5000);
          
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error('Worker not supported'));
      }
    });
  }

  /**
   * 獲取 PDF 錯誤的用戶友好訊息
   */
  static getPdfErrorMessage(error: Error): string {
    if (error.message.includes('Setting up fake worker failed') || 
        error.message.includes('Failed to fetch dynamically imported module')) {
      return 'PDF 處理器初始化失敗。這可能是網路連線問題，請稍後再試';
    } else if (error.message.includes('Invalid PDF')) {
      return 'PDF 檔案格式不正確或已損壞';
    } else if (error.message.includes('password')) {
      return 'PDF 檔案受密碼保護，無法處理';
    } else if (error.message.includes('Worker')) {
      return 'PDF 處理器載入失敗，請重新整理頁面後再試';
    } else {
      return `PDF 處理失敗：${error.message}`;
    }
  }
}

// 自動初始化
PdfConfigService.initializePdfWorker();